import NotFoundError from './NotFoundError';
export default NotFoundError;
